import './RepeatCounter.scss';

const partToModifier = (name) => {
  if (name === 'Hidden') return 'repeat-counter--hidden-note';
  return `repeat-counter--${name.toLowerCase().replace(/\s+/g, '-')}`;
};

const RepeatCounter = ({ count, activeIdx, progress, phase, onTap, partName }) => {
  const partClass = partToModifier(partName);
  return (
    <span className={`repeat-counter ${partClass}`} onClick={onTap}>
      {Array.from({ length: count }, (_, i) => {
        const isBefore = i < activeIdx;
        const isCurrent = i === activeIdx && phase === 'running';
        const isDone = phase === 'done';

        let style;
        if (isDone || isBefore) {
          style = { background: 'var(--rc-color)' };
        } else if (isCurrent) {
          style = {
            background: `conic-gradient(var(--rc-color) ${Math.round(progress * 360)}deg, transparent 0)`,
          };
        } else {
          style = {};
        }

        return <span key={i} className="repeat-counter__circle" style={style} />;
      })}
    </span>
  );
};

export default RepeatCounter;
